import React, { forwardRef } from "react";
import "./filterDialog.scss";
import { Slide, Dialog, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FilterDialog = ({ open, setOpenFilterDialog, children }) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => setOpenFilterDialog(false)}
      TransitionComponent={Transition}
      className="dialog"
    >
      <div className="dialog-close">
        <IconButton
          color="inherit"
          onClick={() => setOpenFilterDialog(false)}
          aria-label="close"
          className="iconBtn"
        >
          <CloseRoundedIcon />
        </IconButton>
      </div>
      <div className="dialog-container">{children}</div>
    </Dialog>
  );
};

export default FilterDialog;
